"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.BackButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.regular16}
  line-height: 24px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: fit-content;
  gap: 6px;
`;
